import { makeStyles } from '@material-ui/core';
import tw from 'twin.macro';

export default makeStyles(() => ({
  root: {
    '&': tw`bg-gray-300 flex items-center justify-center`,
  },
}));
